import { Delete as DeleteIcon } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import type { TestCase } from "./types";

interface DeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedTests: TestCase[];
  isLoading: boolean;
}

export const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  selectedTests,
  isLoading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="delete-dialog-title">
        <Stack direction="row" spacing={1.5} alignItems="center">
          <DeleteIcon color="error" sx={{ fontSize: 20 }} />
          <Typography variant="h6" sx={{ fontSize: 18, fontWeight: 600 }}>
            Delete Test Cases
          </Typography>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="delete-dialog-description" sx={{ mb: 2 }}>
          You are about to delete {selectedTests.length} test case
          {selectedTests.length > 1 ? "s" : ""}. This action cannot be undone.
        </DialogContentText>

        <Paper elevation={0} sx={{ p: 2, bgcolor: "grey.50", borderRadius: 1 }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontSize: 13,
              fontWeight: 600,
              mb: 1,
              color: "text.primary",
            }}
          >
            Tests to be deleted:
          </Typography>
          <Typography variant="body2" sx={{ fontSize: 12, color: "text.secondary" }}>
            {selectedTests.map((test, idx) => (
              <React.Fragment key={test.id ?? idx}>
                {test.name}
                <br />
              </React.Fragment>
            ))}
          </Typography>
        </Paper>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isLoading}
          startIcon={<DeleteIcon />}
        >
          {isLoading ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
